import React from "react";
import CounterBadge from "./counter-badge";

interface TabBadgeProps {
  label: string;
  count: number;
}

const TabBadge: React.FC<TabBadgeProps> = ({ label, count }) => {
  return (
    <div className="flex items-center gap-[6px]">
      <span className="truncate">{label}</span>
      {count > 0 && <CounterBadge count={count} />}
    </div>
  );
};

export default TabBadge;
